<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
   <div> 
   
    
          <vx-card title v-show="step1">
             <div class="mt-5">
              <div class="vx-row">
                <div class="vx-col md:w-1/1 w-full mt-5">
                 <h6 class="mb-2">Cliente</h6>
                 <v-select
              name="customer"
              v-model="customerSelected"
              :options="getCustomersFiltered"
              :loading="isLoadingCustomers"
              :filterable="true"
              :searchable="true"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-validate="'required'"
              placeholder="Digite para buscar (min. 2 caracteres)..."
              @search="onSearchCustomers"
              :no-drop="searchTerm.length > 0 && searchTerm.length < 2"
              :close-on-select="true"
            >
              <template slot="no-options">
                <span v-if="searchTerm.length > 0 && searchTerm.length < 2">
                  Digite pelo menos 2 caracteres
                </span>
                <span v-else-if="isLoadingCustomers">
                  Carregando...
                </span>
                <span v-else>
                  Nenhum cliente encontrado
                </span>
              </template>
            </v-select>
                  <span class="text-danger">{{
                    errors.first("customer")
                  }}</span>
                </div>
              </div>
              <IsDefaulter ref="IsDefaulter" :Defaulter="customerSelected.defaulter" />
                     <br />
              <div class="vx-row" v-show="customerSelected.id">
                <div class="vx-col md:w-1/1 w-full mt-5">
                  <h6 class="mb-2">Endereço: {{ customerSelected.address }}</h6>
                  <h6 class="mb-2">Bairro: {{ customerSelected.district }}</h6>
                  <h6 class="mb-2">Cidade: {{ customerSelected.city }} CEP:  {{ customerSelected.cep }}</h6>
                  <h6 class="mb-2" v-show="customerSelected.cnpj">
                    CNPJ: {{ customerSelected.cnpj }}
                  </h6>
                  <h6 class="mb-2" v-show="customerSelected.cpf">
                    CPF: {{ customerSelected.cpf }}
                  </h6>
                  <h6 class="mb-2">Inscrição Estadual: {{ customerSelected.stateRegistration }}</h6>
                  <h6 class="mb-2">Email: {{ customerSelected.mail }}</h6>
                  <h6 class="mb-2">Telefone: {{ customerSelected.phone }}</h6>
                  <h6 class="mb-2">Ilux: {{ customerSelected.idIlux }}</h6>
                </div> 
              </div>
              <div class="vx-row">
                <div class="vx-col w-3/4 mt-5"></div>
                <div class="vx-col md:w-1/4 mt-1" align="right">
                  <vs-button
                    color="success"
                    type="border"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="addNewData"
                  ></vs-button>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/1 w-full mt-5"> <h6 class="mb-2">Tipo de Pedido</h6></div>
              </div>
             <div class="vx-row">
          <div class="vx-col md:w-1/1 w-full mt-5">
            <InfoOrder :orderType="orderTypeProps" />
          </div>
        </div>
              <br />
              <br />
                     <div class="vx-row">
                <div class="vx-col md:w-1/1 w-1/2 mt-5">
                  <font-awesome-icon
                    :icon="['fas', 'dollar-sign']"
                    class="w-6"
                  />Pagamento
                </div>
                <div class="vx-col md:w-1/1 w-1/2 mt-5">
                  <font-awesome-icon
                    :icon="['fas', 'file-invoice']"
                    class="w-6"
                  />Nota Fiscal
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio
                        color="success"
                        v-model="payOrder"
                        vs-value="Vista"
                        >à Vista</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio
                        color="#1E90FF"
                        v-model="payOrder"
                        vs-value="Prazo"
                        >à Prazo</vs-radio
                      >
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio color="success" v-model="invoice" vs-value="TRA"
                        >Com TRA</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio color="#1E90FF" v-model="invoice" vs-value="NF"
                        >Com NF</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <br />
              <br />
              <div class="vx-row">
                <div class="vx-col md:w-1/1 w-1/2 mt-5">
                  <font-awesome-icon
                    :icon="['fas', 'file-alt']"
                    class="w-6"
                  />Orçamento
                </div>
                <div class="vx-col md:w-1/1 w-1/2 mt-5">
                  <font-awesome-icon
                    :icon="['fa', 'truck']"
                    class="w-6"
                  />Frete
                </div>
              </div>
               <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio color="success" v-model="budget" vs-value="semOrcamento"
                        >Sem Orçamento</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio color="#1E90FF" v-model="budget" vs-value="comOrcamento"
                        >Com Orçamento</vs-radio
                      >
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio color="success" v-model="shipping" vs-value="Cliente"
                        >Cliente</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio color="#1E90FF" v-model="shipping" vs-value="Copyjui"
                        >Copyjui</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <br>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-1/2 mt-5">
                 <h6 class="mb-2">Condição de Pagamento</h6>
                  <vs-input
                    v-model="terms"
                    class="w-full"
                  />
                </div>
              </div> 
              <br>
              <br>
              <div class="vx-row">
                <div class="vx-col md:w-1/1 w-1/2 mt-5">
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="w-6"
                  />Urgência
                </div>
                <div class="vx-col md:w-1/1 w-1/2 mt-5">
                  <font-awesome-icon
                    :icon="['fas', 'phone-volume']"
                    class="w-6"
                  />Origem Ligação
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio color="success" v-model="urgency" vs-value="s"
                        >Com Urgência</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio color="#1E90FF" v-model="urgency" vs-value="n"
                        >Sem Urgência (Reposição)</vs-radio
                      >
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio
                        color="success"
                        v-model="telephoneCall"
                        vs-value="Receptivo"
                        >Receptivo</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio
                        color="#1E90FF"
                        v-model="telephoneCall"
                        vs-value="Ativo"
                        >Ativo</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div> 
              <div class="vx-row">
              <div class="vx-col md:w-1/2 w-1/2 mt-5">
               <h6 class="mb-2">Observação Urgência</h6>
                <vs-input
                  v-model="urgentObservation"
                  class="mt-5 w-full"
                />
              </div>
            </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/3 w-full mt-5">
                    <h6 class="mb-2">Data</h6>
                  <div>
                    <datepicker
                      placeholder="Selecione a Data"
                      :language="languages['ptBR']"
                      format="dd/MM/yyyy"
                      v-model="date"
                    ></datepicker>                  
                  </div>
                 
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-1/2 mt-5">
                 <h6 class="mb-2">Nome do Responsável</h6>
                  <vs-input
                    v-model="personName"
                    class="w-full"
                    v-validate="'required'"
                    name="personName"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-1/2 mt-5">
                 <h6 class="mb-2">Cargo</h6>
                  <vs-input
                    v-model="personRole"
                    class="w-full"
                  />
                </div>
              </div>
               <span class="text-danger">{{ errors.first("personName") }}</span>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5" v-if="this.$store.state.user.userGroup == 'admin'">
                  <h6 class="mb-2">Consultor</h6>
                  <v-select
                    name="user"
                    v-model="userSelected"
                    :options="getUsers"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-validate="'required'"
                  />
                  <span class="text-danger">{{
                    errors.first("user")
                  }}</span>
                </div>
              </div>
               <div class="vx-row">
              <div class="vx-col md:w-1/2 w-1/2 mt-5">
               <h6 class="mb-2">Observação</h6>
                  <vs-input
                    v-model="generalObservation"
                    class="w-full"
                  />
                </div>
              </div>
              <AddNewCustomer
                :isSidebarActive="addNewDataSidebar"
                @closeSidebar="toggleDataSidebar"
                :data="sidebarData"
              />

             <vs-button class="float-right" @click="goStep2">Próximo</vs-button>
        <br />
        <br />
      </div>
         </vx-card>
            <vx-card v-show="step2">
              <div class="vx-row">
                <div class="vx-col md:w-1/1 w-full">
                  <div class="mt-5">
                  <TableProducts
                    :data="productsSelected"
                    v-on:selectProducts="selectProducts"
                    :orderType="orderType"
                    />
                   <vs-button class="float-left" @click="goStep1">Voltar</vs-button>
                    <vs-button class="float-right" @click="submit">Salvar</vs-button>
                    <br />
                    <br />
                </div>
                </div>
              </div> 
            </vx-card>

         
       
      </div>
   
</template>


<script>
import TableProducts from "../orderProducts/component/EditTable.vue";
import AddNewCustomer from "../customers/AddNewCustomer";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { momentJS, numberJS } from "@/helpers";
import { Validator } from "vee-validate";
import IsDefaulter from "../IsDefaulter/Index.vue";
import InfoOrder from "./InfoBudget";
import axios from "axios";
import { baseApiUrl } from "@/global";
import router from "@/router";
const dict = {
  custom: {
    customer: {
      required: "Selecione o cliente",
    },
    user: {
      required: "Selecione o Consultor",
    },
    personName: {
      required: "Digite o nome do Responsável",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: {
    "v-select": vSelect,
    AddNewCustomer,
    TableProducts,
    Datepicker,
    IsDefaulter,
    InfoOrder
  },
    props: {
    orderTypeProps: {
      type: String,
    },
  },
  computed: {
     // Computed otimizado - agora pega direto do state
     getCustomersFiltered() {
      return this.$store.state.customers.customersFiltered || []
    },
    
    // Novo computed para verificar loading
    isLoadingCustomers() {
      return this.$store.state.customers.isLoading
    },
    getUsers() {
      return this.$store.state.usersFiltered;
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.products.length;
    },
    getProducts() {
      return this.$store.state.products;
    },
  },
  data() {
    return {
      step1: true,
      step2: false,
      customerSelected: [],
      orderType: "Peças",
      payOrder: "Vista",
      invoice: "TRA",
      budget: "semOrcamento",
      telephoneCall: "Receptivo",
      urgency: "n",
      urgentObservation: '',
      generalObservation: '',
      shipping: "Cliente",
      itemsPerPage: 100,
      products: [],
      personName: null,
      personRole: null,
      productsSelected: [],
      productsConfirmed: [],
      userSelected: null,
      date: null,
      languages: lang, 
      addNewDataSidebar: false,
      sidebarData: {},
      payload: {},
      loadingWizard: false,
      terms : "",
      searchTerm: '',
      maxResults: 50,
      minSearchLength: 2,
    };
  },
  methods: {
     // Método debounced para busca otimizada
     onSearchCustomers: _.debounce(async function(search) {
      this.searchTerm = search || ''
      
      try {
        await this.$store.dispatch('customers/searchCustomers', {
          searchTerm: this.searchTerm,
          limit: this.maxResults
        })
      } catch (error) {
        console.error('Erro na busca de clientes:', error)
        this.$vs.notify({
          title: 'Erro',
          text: 'Erro ao buscar clientes. Tentando busca local...',
          color: 'warning'
        })
      }
    }, 300),

    // Método para pré-carregar dados essenciais
    async preloadCustomersData() {
      try {
        const payload = {
          loading: this.$vs.loading,
          idOrder: null,
          typeOrder: this.endpointType,
          idCustomer: this.customerSelected.id,
        }
        
        // Carregar todos os clientes uma vez
        await this.$store.dispatch("customers/fetchCustomersItems", payload)
        
        // Aplicar busca inicial vazia para mostrar primeiros resultados
        await this.$store.dispatch('customers/searchCustomers', {
          searchTerm: '',
          limit: this.maxResults
        })
        
      } catch (error) {
        console.error('Erro ao pré-carregar clientes:', error)
        this.$vs.notify({
          title: 'Aviso',
          text: 'Erro ao carregar lista de clientes',
          color: 'warning'
        })
      }
    },
    goStep1() {
      this.step1 = true;
      this.step2 = false;
    },
    async goStep2() {
      let isDefaulter = this.$refs.IsDefaulter.isDefaulter(this.customerSelected.defaulter);
      const haveErrors = !(await this.$validator.validateAll()&& !isDefaulter );
      if (haveErrors) return;
      this.step1 = false;
      this.step2 = true;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    selectProducts(products) {
      this.productsSelected = products;
    },
   async submit() {
      let fk_idUser;
      if (this.$store.state.user.userGroup == "admin") {
        fk_idUser = this.userSelected.id;
      } else {
        fk_idUser = this.$store.state.user.idUser;
      }

      let budget = {
        corporateName: this.customerSelected.corporateName,
        fk_idCustomer: this.customerSelected.id,
        orderType: this.orderTypeProps,
        fk_idUser: fk_idUser,
        itemsOrder: this.productsSelected,
        gold: this.gold,
        terms: this.terms,
        dateOrder: this.date,
        totalOrder: numberJS().totalOrder(this.productsSelected),
        payOrder: this.payOrder,
        personName: this.personName,
        personRole: this.personRole,
        trash: "N",
        creditOperator: this.creditOperator,
        purchaseOption: this.purchaseOption,
        generalObservation: this.generalObservation,
        shipping: this.shipping,
        createBy: this.$store.state.user.idUser,
        createAt: momentJS().getDateTime(),
      };
      if(budget.fk_idCustomer == null || budget.fk_idCustomer == undefined) {
        this.$vs.notify({
          title: "Atenção",
          text: "Selecione um cliente",
          color: "warning",
        });
        return;
      }
      try {
        this.$vs.loading();
        const response = await axios.post(
          `${baseApiUrl}/budget/save`,
          budget
        );
        console.log(response);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        router.push("/orcamentos").catch(() => {});
      } catch (error) {
        console.log(error);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    }
  },

  async created() {
   
    this.date = momentJS().getDateTimeLocal();
    await this.preloadCustomersData()
    let payload = {
      loading: this.$vs.loading,
    };
   // this.$store.dispatch("customers/fetchCustomersItems", payload);
    this.$store.dispatch("fetchProductsItems", payload);
    this.$store.dispatch("fetchAllUsers", payload);
 // Limpar cache expirado periodicamente
 setInterval(() => {
      this.$store.dispatch('customers/clearExpiredCache')
    }, 5 * 60 * 1000) // A cada 5 minutos
  },
  
  // Limpar intervalos ao destruir componente
  beforeDestroy() {
    // Limpar qualquer timer se necessário
  }
};
</script>

<style scoped>
/* Estilos para melhorar a performance visual */
.vs__dropdown-toggle {
  transition: border-color 0.15s ease-in-out;
}

.vs__dropdown-toggle:focus-within { 
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

/* Otimizar scroll do dropdown */
.vs__dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Loading state */
.vs__open-indicator {
  transition: transform 0.15s ease;
}
</style>

